import React, {useEffect, useState} from "react";
import Button from "../../../components/Button";
import DashboardPanel from "../../../components/DashboardPanel";
import {Set} from "immutable";
import IdleActions from "./actions/_1_IdleActions";
import Checkbox from "../../../components/Checkbox";
import {withWarehousePackages} from "../../../lib/WarehouseHelper";
import OrderWithPackages from "./OrderWithPackages";


// In the Due to process panel, packages are grouped by their jobId.
// Only general info about the order are displayed.
const Panel = (props) => {
  const {
    warehouseId, packages,
    getJobById, getAlertInfoForJobId, getTagsForJobId,
  } = props;

  // Packages are grouped by jobId
  const [jobs, setJobs] = useState({});

  useEffect(() => {
    setJobs(packages.reduce((acc, p) => {
      const jobId = p.get("jobId");
      if (!acc[jobId]) {
        // Init order info
        acc[jobId] = {
          ...getJobById(jobId),
          id: jobId, // keep in mind as the acc keys will be thrown away
          packages: [],
          alert: getAlertInfoForJobId(jobId),
          tags: getTagsForJobId(jobId),
        }
      }

      acc[jobId].packages.push(p);

      return acc;
    }, {}));
  }, [packages, getJobById, getAlertInfoForJobId, getTagsForJobId]);

  const [checkedJobIds, setCheckedJobIds] = useState(Set());
  const [jobsElems, setJobsElems] = useState();

  useEffect(() => {
    const toggleOrderId = (jobId) => {
      setCheckedJobIds(checkedJobIds.includes(jobId) ? checkedJobIds.delete(jobId) : checkedJobIds.add(jobId));
    }
    const headerActionRenderer = (jobId) => (
      <Checkbox
        onClick={() => toggleOrderId(jobId)}
        checked={checkedJobIds.includes(jobId)}
      />
    );

    // Update the job elem any time the orders or checked job ids change
    setJobsElems(Object.values(jobs).map(
      (o) => <OrderWithPackages key={o.id} {...o} warehouseId={warehouseId} headerActionRenderer={headerActionRenderer} />
    ));
  }, [jobs, checkedJobIds]);

  const toggleAll = () => {
    checkedJobIds.size > 0
      ? setCheckedJobIds(Set())
      : setCheckedJobIds(Set(Object.keys(jobs)));
  }
  const headerAction = (
    <Button link
      onClick={toggleAll}
      active={packages.size > 0}
      label={checkedJobIds.size > 0 ? "Deselect All" : "Select All"} />
  );

  const bottomAction = (
    <IdleActions
      warehouseId={warehouseId}
      jobIds={checkedJobIds}
      packages={packages}
      afterClick={() => setCheckedJobIds(Set())}
    />
  );
  
  return (
    <DashboardPanel title="Due to Process" theme="idle"
      headerAction={headerAction}
      footer={bottomAction}>
      { jobsElems }
    </DashboardPanel>
  );
}


export default withWarehousePackages(Panel);
